import googlePlayRetina from 'marketing-website/media/images/pages/apps/google-play@2x.png';
import appStoreRetina from 'marketing-website/media/images/pages/apps/app-store@2x.png';
import popLogoRetina from 'marketing-website/media/images/pages/pop/pop-logo@2x.png';

const assets = {
  googlePlay: {
    alt: 'Google Play',
    maxWidth: 180,
    src: googlePlayRetina,
  },
  appStore: {
    alt: 'Apple App Store',
    maxWidth: 180,
    src: appStoreRetina,
  },
  logo: {
    alt: 'POP logo',
    maxWidth: 161,
    src: popLogoRetina,
    hasShadow: false,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/pop/assets.js